import { CompanyListCompanyDto } from 'models/dtoTypes';
import CompanyGenericSearchDialog from 'kosmos/components/CompanyGenericSearchDialog';
import { CompanyDetailedDtoWithSelector } from 'kosmos/models';

export interface IField {
  required?: boolean;
  label: string;
  widget: string;
  name: string;
  description?: string;
  options?: { value: string; label: string }[];
  placeholder?: string;
}

interface Props {
  selectedCompanyListItem?: CompanyListCompanyDto;
  open: boolean;
  onClose: () => void;
  onSelect: (companyListItemId: string, company: CompanyDetailedDtoWithSelector) => Promise<void>;
}

function SearchCompanyDialog(props: Props): JSX.Element {
  const { selectedCompanyListItem, open, onClose, onSelect } = props;
  const handleClose = () => {
    onClose();
  };

  async function handleFinishSelect(company: CompanyDetailedDtoWithSelector) {
    await onSelect(selectedCompanyListItem?.id || '', company);
    onClose();
  }

  const renderCardContent = () => {
    return (
      <CompanyGenericSearchDialog
        initialCompanyNumber={selectedCompanyListItem?.registrationNumbers || ''}
        initialCompanyName={selectedCompanyListItem?.name || ''}
        initialCountry={selectedCompanyListItem?.countryCode || ''}
        initialAddressLine={selectedCompanyListItem?.address || ''}
        initialPostalCode={selectedCompanyListItem?.postalCode || ''}
        onClose={handleClose}
        onSelectCompany={handleFinishSelect}
        open={open}
      />
    );
  };

  return open ? renderCardContent() : <></>;
}

export default SearchCompanyDialog;
